function escapeCsvField(value) {
  if (value === null || value === undefined) {
    return "";
  }
  const s = String(value);
  if (/[",\r\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/**
 * Tutor aggregate table as shown (search + sort applied; all pages).
 * @param {Array<object>} processedRows from TrendlineView processedTutorData
 * @param {Array<{ key: string, label: string }>} tutorColumnConfigs
 */
export function tutorAggregateToCsvString(processedRows, tutorColumnConfigs) {
  if (!processedRows?.length) {
    return "";
  }
  const configs = tutorColumnConfigs || [];
  const headers = ["Tutor Name", "Sessions", ...configs.map((c) => c.label)];
  const rows = processedRows.map((tutor) => [
    tutor.teacherName,
    tutor.sessionCount,
    ...configs.map((cfg) => {
      const v = tutor[cfg.key];
      return v === null || v === undefined ? "-" : v;
    }),
  ]);
  return [
    headers.map(escapeCsvField).join(","),
    ...rows.map((r) => r.map(escapeCsvField).join(",")),
  ].join("\r\n");
}

/**
 * @param {string} filenameBase filename without extension
 */
export function downloadTutorAggregateCsv(
  processedRows,
  tutorColumnConfigs,
  filenameBase
) {
  const csv = tutorAggregateToCsvString(processedRows, tutorColumnConfigs);
  if (!csv) {
    return;
  }
  const blob = new Blob([`\ufeff${csv}`], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const safeBase = (filenameBase || "analysis-by-tutor").replace(
    /[^a-zA-Z0-9-_]+/g,
    "-"
  );
  a.download = `${safeBase}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
